<template>
    <div>
        <div class="form-row">
            <div class="col col-12" :class="col_material">
                <az-input
                    v-if="selectMode == 'S'"
                    placeholder="Selecione o material..."
                    :sizing="big ? '' : 'sm'"
                    icon="fas fa-plus"
                    type="autocomplete" 
                    optionsMode="aql"
                    service="estoque_items.index"
                    :optionsSync="false"
                    :optionsParm="{ todos: kits, selecao: true, mav: true, consumo_paciente: consumo_paciente }"
                    :optionsName="( kits ? 'estoque_items.kits.index' : 'estoque_items.index' ) + ( consumo_paciente ? '.consumo_paciente' : '' )"
                    v-model="novo_item" 
                    ref="selecao"
                    @selecionado="selecionar_item()" />
                
                <div class="form-row" v-else-if="selectMode == 'B'">
                    <div class="col col-12" :class="novo_item ? 'col-md-4' : 'col-md-12'">
                        <az-input
                            placeholder="Leitura do código de barras..."
                            :sizing="big ? '' : 'sm'"
                            v-model="codigo_barra" 
                            ref="selecao"
                            @onEnter="leitura()">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button class="btn btn-outline-secondary" @click.prevent="leitura_barcode = !leitura_barcode">
                                        <i class="fa-solid fa-barcode fa-fw" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-8" v-if="novo_item">
                        <az-input   
                            type="label"
                            :sizing="big ? '' : 'sm'"
                            :label="novo_item ? novo_item.search : ''" />
                    </div>
                </div>
            </div>
            <template v-if="selecao_lote && novo_item">
                <div class="col col-12 col-md-2">
                    <az-input
                        v-if="entrada"
                        :sizing="big ? '' : 'sm'"
                        placeholder="Lote..."
                        ref="lote"
                        v-model="lote.numero" 
                        @onEnter="incluir_lote()" />

                    <az-input
                        v-else
                        :sizing="big ? '' : 'sm'"
                        placeholder="Lote..."
                        ref="lote"
                        type="autocomplete" 
                        optionsMode="aql"
                        service="estoque_lotes.index"
                        :optionsParm="{ id_estoque_item: novo_item.id_estoque_item, id_estoque_local: id_estoque_local }"
                        :optionsSync="true"
                        v-model="lote.item" 
                        @selecionado="selecionar_lote()">
                        <template v-slot:buttonposb>
                            <div class="input-group-append" v-if="!lote.item">
                                <span class="input-group-text" id="basic-addon2" v-if="lote.loading">
                                    <div class="spinner-grow spinner-grow-sm" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                </span>
                                <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                                    @click="buscar_lotes()" v-else>
                                    <i class="fa fa-search" aria-hidden="true"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-2">
                    <az-input
                        :sizing="big ? '' : 'sm'"
                        type="date"
                        icon="far fa-calendar-check"
                        buttonToolTip="Validade"
                        :edicao="lote.numero ? true : false"
                        v-model="lote.validade"
                        @onEnter="incluir_lote()" />
                </div>
            </template>
            <template v-if="infoqt && novo_item">
                <div class="col col-12 col-md-2">
                    <template v-if="novo_item.fl_fracionado && novo_item.st_unidade_compra && novo_item.st_unidade_compra != novo_item.st_unidade_estoque && ( oc || nf )">
                        <az-input
                            buttonToolTip="Quantidade"
                            placeholder="Qtde..."
                            type="money"
                            :precision="3"
                            :sizing="big ? '' : 'sm'"
                            ref="quantidade_compra_frac"
                            v-model="quantidade_compra"
                            :iconEnd="novo_item.st_unidade_compra ? { text: novo_item.st_unidade_compra } : null" 
                            @onEnter="incluir_lote()" />
                    </template>
                    <template v-else>
                        <az-input
                            v-if="novo_item.st_unidade_compra && novo_item.st_unidade_compra != novo_item.st_unidade_estoque && ( oc || nf )"
                            buttonToolTip="Quantidade"
                            placeholder="Qtde..."
                            type="number"
                            :sizing="big ? '' : 'sm'"
                            ref="quantidade_compra"
                            :min="0"
                            :max="99999999"
                            v-model="quantidade_compra"
                            :iconEnd="novo_item.st_unidade_compra ? { text: novo_item.st_unidade_compra } : null" 
                            @onEnter="incluir_lote()" />
                        <az-input
                            buttonToolTip="Quantidade"
                            placeholder="Qtde..."
                            type="number"
                            :sizing="big ? '' : 'sm'"
                            v-model="quantidade"
                            ref="quantidade"
                            :min="0"
                            :max="99999999"
                            :iconEnd="novo_item.st_unidade_estoque ? { text: novo_item.st_unidade_estoque } : null" 
                            @onEnter="incluir_lote()" />
                    </template>
                </div>
            </template>
            <template v-if="infopreco && novo_item">
                <div class="col col-12 col-md-2">
                    <az-input
                        placeholder="Preço..."
                        type="money"
                        :sizing="big ? '' : 'sm'"
                        :precision="6"
                        v-model="preco"
                        ref="preco"
                        @onEnter="incluir_lote()">
                        <template v-slot:button-pre>
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">Preço</span>
                            </div>
                        </template>
                    </az-input>
                </div>
            </template>
            <div class="col col-12 col-md-1 d-flex flex-column" v-if="!barcode_only">
                <template v-if="novo_item">
                    <button type="button" class="btn btn-sm btn-success" data-toggle="tooltip" data-placement="top" title="Incluir Item"
                        @click="incluir_lote()">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                </template>

                <div class="btn-group" role="group" aria-label="Basic example" v-else>
                    <button type="button" class="btn btn-sm" :class="selectMode == 'S' ? 'btn-secondary' : 'btn-outline-secondary'" @click="tipo_selecao('S')"
                        data-toggle="tooltip" data-placement="top" title="Seleção do item por busca de descrição.">
                        <i class="fas fa-search-plus"></i>
                    </button>
                    <button type="button" class="btn btn-sm" :class="selectMode == 'B' ? 'btn-secondary' : 'btn-outline-secondary'" @click="tipo_selecao('B')"
                        data-toggle="tooltip" data-placement="top" title="Seleção do item por código de barras.">
                        <i class="fas fa-barcode fa-fw"></i>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="selectMode == 'B' && leitura_barcode" style="max-width: 480px;">

            <div id="qr-code-full-region"></div>

            <qrcode-scanner
                :qrbox="250" 
                :fps="10" 
                style="width: 300px;"
                @result="onScan"
            />

            <video id="beepElemenMaterialtId" src="/store-scanner-beep-90395.mp3" playsinline preload="auto" style="height: 10px;"></video> 

        </div>

        <ul class="list-group" v-if="novo_item && lotes && lotes.length">
            <li class="list-group-item d-flex justify-content-between" v-for="(item_lote, ilx) in lotes" :key="ilx">
                <div>
                    <a href="#" @click.prevent="selecionar_lote_lista(item_lote)">{{ item_lote.search }}</a>

                    <span v-if="item_lote.fl_consig" class="small text-muted ml-2">
                        (Consig)
                        <span v-if="item_lote.fornecedor">
                            {{ item_lote.fornecedor.search }}
                        </span>
                        <span v-else-if="item_lote.id_fornecedor">
                            Forn: #{{ item_lote.id_fornecedor }}
                        </span>
                    </span>
                </div>
                <div>
                    <span class="mr-2">{{ item_lote.saldo.qtd }}</span>
                    <i class="fas fa-boxes mr-5"></i>
                    
                    <span class="mr-2">{{ $util.getFormatDate(item_lote.dt_validade) }}</span>
                    <i class="fas fa-hourglass-end"></i>
                </div>
            </li>
        </ul>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() { 
        return { 
            novo_item: null, 
            selectMode: 'S', 
            selecao_lote: false, 
            quantidade: "", 
            lote: { 
                numero: "",
                validade: "", 
                item: null, 
                loading: false, 
            },
            lotes: null, 
            codigo_barra: "", 
            preco: null, 
            leitura_barcode: false, 
            last_barcode: "",
        }
    },

    components: { 
        AzInput,
    },

    props: ['entrada', 'infoqt', 'id_estoque_local', 'infopreco', 'oc', 'nf', 'blocklote', 'kits', 'barcode_only', 'big', 'consumo_paciente'],

    computed: { 
        col_material: function() { 
            if ( this.barcode_only )
                return 'col-md-12';

            if ( !this.novo_item )
                return 'col-md-11';
                
            let cols = this.selecao_lote ? 7 : 11;

            if ( this.novo_item && this.infoqt ) { 
                cols = cols - 2;
            }

            if ( this.novo_item && this.infopreco ) { 
                cols = cols - 2;
            }

            return 'col-md-' + cols;
        }
    },
    
    methods: { 
        item_selecionado() { 
            return this.novo_item ? this.novo_item.search : '';
        },

        beep () { 
            const el = document.getElementById("beepElemenMaterialtId");
            el.play();
        },

        onScan (data) { 

            console.log(data);

            if ( data.text == this.last_barcode ) { 
                return; 
            }

            this.codigo_barra = data.text;
            this.last_barcode = data.text;

            this.leitura(false);

            setTimeout(() => { 
                this.last_barcode = "";
            }, 2500);

            this.beep();
        },

        reset() { 
            this.novo_item = "";
            this.lote.item = "";
            this.lotes = null;
        },

        buscar_lotes() { 
            this.lote.loading = true;

            this.$util.loadItem(this, { 
                service: "estoque_lotes",
                func: 'index',
                parms: { 
                    id_estoque_item: this.novo_item.id_estoque_item, 
                    id_estoque_local: this.id_estoque_local,
                    saldos: true, 
                }
            })
            .then(res => { 
                this.lotes = _.orderBy(
                    res.filter(item => item.saldo && item.saldo.qtd > 0),
                    'dt_validade'
                );
            })
            .finally(() => { 
                this.lote.loading = false;
            });
        },

        tipo_selecao(tipo) { 
            this.selectMode = tipo;

            this.$nextTick(() => { 
                this.$refs.selecao.$refs.input.focus ();
            }); 
        },

        leitura(beep = true) { 
            if ( !this.codigo_barra )
                return;

            this.novo_item = "";
            this.selecao_lote = false;

            if ( beep ) { 
                // this.beep();
            }

            this.$util.load(this, { 
                service: 'estoque_items',
                func: 'codigo_barra',
                parms: { 
                    codigo_barra: this.codigo_barra,
                },
                loadTo: res => { 
                    // console.log('Busca', res);

                    if ( res && res.item ) { 
                        if ( res.item.fl_kit ) { 

                            this.novo_item = { 
                                ...res.item,
                                composicao: res.composicao,
                                show_comp: false, 
                                quantidade: 1 
                            };

                            this.$nextTick(() => { 
                                this.selecionar_item();
                            });
                            
                        } else if ( res.item.fl_controla_lote && !this.barcode_only ) { 

                            this.novo_item = { 
                                ...res.item,
                                composicao: res.composicao,
                                show_comp: false, 
                                quantidade: 1 
                            };

                            this.informar_lote();

                            if ( res.lote ) { 
                                this.lote.numero = res.lote.st_lote;
                                this.lote.validade = res.lote.dt_validade;
                                this.lote.item = res.lote;

                                this.$nextTick(() => {
                                    // this.$refs.quantidade.$refs.input.focus ();
                                    this.incluir_lote();
                                });
                            }

                        } else { 

                            this.$emit('selecionado', { 
                                ...res.item, 
                                composicao: res.composicao,
                                show_comp: false, 
                                quantidade: 1 
                            });

                        }

                    }

                    this.$nextTick(() => { 
                        this.codigo_barra = "";
                    });
                }
            });
        },

        selecionar_lote_lista(item) { 
            this.lote.item = _.cloneDeep(item);
            this.lotes = null;
            this.selecionar_lote();
        },

        selecionar_lote () { 
            if ( this.lote ) { 

                this.lote.numero = _.get(this.lote, 'item.st_lote');
                this.lote.validade = _.get(this.lote, 'item.dt_validade');
                this.lote.loading = false;

                this.$nextTick(() => {
                    this.$refs.quantidade.$refs.input.focus ();
                });

            }
        },

        informar_lote() { 
            this.lote.numero = "";
            this.lote.validade = "";
            this.lote.item = "";
            this.lote.loading = false;

            if ( !this.blocklote ) { 
                this.selecao_lote = true;

                this.$nextTick(() => {
                    this.$refs.lote.$refs.input.focus ();
                });
            }
        },

        incluir_kit (id_estoque_item, qtde = 1) { 
            this.novo_item = "";
            this.lote.item = "";
            this.lotes = null;

            if ( !qtde )
                qtde = 1;

            this.$util.load(this, { 
                service: 'estoque_items', 
                parms: { 
                    where: { id_estoque_item: id_estoque_item },
                    kit: true, 
                    cadastro: true, 
                },
                loadTo: res => { 

                    if ( res && res.length == 1 ) { 
                        res[0].componentes.forEach(material => {
                            this.$emit('selecionado', { 
                                ...material.item, 
                                quantidade: material.in_quantidade * qtde, 
                                lote: this.lote,
                                id_estoque_item_kit: id_estoque_item,
                            });     
                        });
                    }
                }
            });
        },

        selecionar_item() { 

            if ( this.novo_item ) { 

                this.quantidade = "";
                this.quantidade_compra = "";
                this.lotes = null;

                if ( this.infoqt && ( this.oc || this.nf ) ) { 
                    if ( this.novo_item.st_unidade_compra && this.novo_item.st_unidade_compra != this.novo_item.st_unidade_estoque ) { 
                        this.quantidade = this.novo_item.in_fator_conversao;
                    }
                }

                if ( this.novo_item.fl_controla_lote && !this.oc && !this.blocklote ) { 
                    this.informar_lote();
                    return;
                }

                if ( this.novo_item.fl_kit ) { 
                    let id_estoque_item = this.novo_item.id_estoque_item;

                    if ( !this.infoqt ) { 
                        
                        this.$nextTick(() => {
                            this.incluir_kit(id_estoque_item);
                        });
                        return;

                    }

                }

                this.selecao_lote = false;

                if ( this.infoqt ) { 

                    if ( ( this.oc || this.nf ) && this.novo_item.st_unidade_compra && this.novo_item.st_unidade_compra != this.novo_item.st_unidade_estoque ) { 

                        this.$nextTick(() => {
                            if ( this.$refs.quantidade_compra ) { 
                                this.$refs.quantidade_compra.$refs.input.focus ();
                            }
                        });

                    } else { 

                        this.$nextTick(() => {
                            this.$refs.quantidade.$refs.input.focus ();
                        });

                    }

                    return;

                }

            }

            this.$nextTick(() => {
                if ( this.novo_item ) { 
                    this.$emit('selecionado', { ...this.novo_item, lote: this.lote });
                }
                this.novo_item = "";
                this.lote.item = "";
                this.lotes = null;
            });

        },

        incluir_lote() { 
            $('[data-toggle="tooltip"]').tooltip('dispose');

            if ( this.novo_item && this.novo_item.fl_kit ) { 
                let id_estoque_item = this.novo_item.id_estoque_item;

                this.$nextTick(() => {
                    this.incluir_kit(id_estoque_item, this.leitura_barcode ? 1 : this.quantidade);
                });
                return;
            }

            let novo = { 
                ...this.novo_item, 
                lote: this.lote, 
                quantidade: ( this.selectMode == 'B' ) ? 1 : this.quantidade,
                quantidade_compra: ( this.selectMode == 'B' ) ? 1 : this.quantidade_compra, 
                preco: this.preco, 
            };

            console.log('Novo item selecionado', novo);

            novo = _.cloneDeep(novo);

            this.$emit('selecionado', novo);

            this.selecao_lote = false;
            this.novo_item = "";
            this.lote.item = "";
            this.lote.numero = "";
            this.lote.validade = "";
            this.lotes = null;
            this.preco = 0;

            this.$refs.selecao.$refs.input.focus ();
        }
    },

    mounted() { 
        if ( this.barcode_only ) { 
            this.selectMode = 'B';   
        }
    },
    
    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }
}
</script>